import PageContainerBlank from '../components/PageContainer/PageContainerBlank';
import PageEndBlank from '../components/PageContainer/PageEndBlank';
import PostcardDeck from '../components/PostcardDeck/PostcardDeck';

const Events = () => {
	return (
		<div>
			<PageContainerBlank />

			<h1>Holy Name Events</h1>
			<p className="centered"><span className="tab"></span>The Holy Name Society sponsors various events throughout the year to serve our community and support our charitable initiatives. Below is a sample of some of our yearly activities.</p>
			<br />
			<PostcardDeck />
			<p className="centered">You can find photos and particulars of each event on the <a href="/previous_events">Previous Events</a> page.</p>

			<PageEndBlank />
		</div>
	);
};

export default Events;